import { useLoaderData } from 'react-router';
import GconResults from '@/components/gcon/GconResults';

const GconSessionRoute = () => {
  const { session } = useLoaderData();

  // Keyed by session so switching sessions resets filters, tabs and chat
  return <GconResults key={session.id} session={session} />;
};

export default GconSessionRoute;
